import React, { Component } from 'react'
import Line from '../Line'
import { translation, enumtranslate } from '../../../../utils/helpers'

class DeviationLine extends Component {
  render () {
    let reason = this.props.reason
    if (!reason) return null

    let enumName = ''
    let deviationName = ''

    if (this.props.isCustomReason) {
      enumName = (reason.DeviationGroup === 0) ? 'InternalDeviationTypes' : 'ExternalDeviationTypes'
      deviationName = reason.CustomReason
    } else {
      enumName = (reason.DeviationType.ClassId - 1 === 0) ? 'InternalDeviationTypes' : 'ExternalDeviationTypes'
      deviationName = translation(enumtranslate(enumName, reason.DeviationType.Type))
    }

    return (
      <Line text={deviationName} onDelete={this.props.onDelete && this.props.onDelete.bind(this, this.props.reason)} subLine={!this.props.editable} />
    )
  }
}

export default DeviationLine



// WEBPACK FOOTER //
// ./src/app/shared/components/Extent/DeviationLine/index.js